module.exports = __webpack_public_path__ + "static/media/cycling.ac13ae99.gif";